// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prototyping-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 120px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.prototyping-text {
  width: 60%;
}

.prototyping-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 10px;
}

.prototyping-text p {
  font-size: 1em;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

.prototyping-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.prototyping-button:hover {
  background-color: #009624;
}

.prototyping-image {
  position: relative;
  width: 35%;
}

.services-image {
  width: 60%;
  height: auto;
  border-radius: 8px;
}

.overlay-text {
  position: absolute;
  bottom: 10%;
  left: 10%;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 1.2em;
  font-weight: bold;
}

@media (max-width: 768px) {
  .prototyping-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
  }

  .prototyping-text {
    width: 100%;
  }

  .prototyping-image {
    width: 100%;
  }

  .services-list li {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Prototyping/Prototyping.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".prototyping-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 120px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.prototyping-text {\n  width: 60%;\n}\n\n.prototyping-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.prototyping-text p {\n  font-size: 1em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n.prototyping-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.prototyping-button:hover {\n  background-color: #009624;\n}\n\n.prototyping-image {\n  position: relative;\n  width: 35%;\n}\n\n.services-image {\n  width: 60%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.overlay-text {\n  position: absolute;\n  bottom: 10%;\n  left: 10%;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 1.2em;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .prototyping-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 20px;\n  }\n\n  .prototyping-text {\n    width: 100%;\n  }\n\n  .prototyping-image {\n    width: 100%;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
